<span #triggerElement>
<ng-content select="[trigger]"></ng-content>
</span>
@defer (on idle) {
  @if (visible()) {
    <div [class]="'fixed z-[10000]' + containerClass()" [style.left]="left() + 'px'" [style.top]="top() + 'px'" #dropDown>
      <div [className]="'absolute bg-white z-[10000] top-full left-[-20px] flex flex-col gap-1.5 shadow text-sm ' + overrideClass()">
        @for (t of items(); track $index + '__item_dropdown') {
          @if (t.divider()) {
            <div class="w-[90%] m-auto h-[1px] px-2 bg-black"></div>
          } @else {
            <div class="flex gap-2 items-center " (click)="visible.set(false)">
              <ng-container *ngTemplateOutlet="t.templateRef"></ng-container>
            </div>
          }
        }
      </div>
    </div>
  }
}
